import { useEffect, useState, forwardRef } from 'react';
import Image from '../../../atoms/Image';
import TableRowItemMobile from './TableRowItem';
import shevron_down from '../../../assets/images/shevron_down.svg';
import shevron_up from '../../../assets/images/shevron_up.svg';

import './styles.scss';

export type contentColors = 'navy' | 'grey' | 'green' | 'red';

export type RowItemValue = string | number | JSX.Element;

export interface IRow {
  id: number;
  name?: string;
  content: {
    value: RowItemValue;
    color: contentColors;
  };
  handleClick?(): void;
  width?: number;
}

export interface ITableCard {
  card: IRow[][];
  footer?: JSX.Element;
  opened?: boolean;
  onCardClick?(): void;
  key?: string;
}

interface ITableCardProps {
  data: ITableCard;
}

const TableCardMobile = forwardRef<HTMLDivElement, ITableCardProps>(
  ({ data }, ref) => {
    const [open, setOpen] = useState(data.opened);

    useEffect(() => {
      if (data.opened) {
        setOpen(data.opened);
      }
    }, [data.opened]);

    const handleToggle = () => {
      setOpen(!open);
    };

    const list = open ? data.card : data.card.slice(0, 1);

    return (
      <div className='table_mobile__card' onClick={data.onCardClick} ref={ref}>
        {list.map((row, index) => (
          <div
            key={index}
            className={`table_mobile__card__content${
              data.opened ? ' table_mobile__card__content--opened' : ''
            }`}
          >
            <div
              className={`table_mobile__card__content__row${
                data.opened ? ' table_mobile__card__content__row--opened' : ''
              }`}
            >
              {row.map((item, index) => (
                <TableRowItemMobile
                  key={item.id}
                  opened={data.opened}
                  index={index}
                  {...item}
                />
              ))}
            </div>
          </div>
        ))}

        {open && data.footer && (
          <>
            <div className='table_mobile__card__separator' />
            <div className='table_mobile__card__footer'>{data.footer}</div>
          </>
        )}
        {!data.opened && (
          <div className='table_mobile__card__icon' onClick={handleToggle}>
            <Image size='m' src={open ? shevron_up : shevron_down} />
          </div>
        )}
      </div>
    );
  }
);

TableCardMobile.displayName = 'TableCardMobile';

export default TableCardMobile;
